"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = StoredSIM;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _styles = require("@sart/styles");
var _icons = require("@sart/icons");
var _content = require("@sart/content");
var _Text = _interopRequireDefault(require("./Text"));
var _Label = _interopRequireDefault(require("./Label"));
var _Space = _interopRequireDefault(require("./Space"));
var _Anchor = _interopRequireDefault(require("./Anchor"));
function StoredSIM(props) {
  var content = (0, _content.useContent)();
  var value = props.value,
    editable = props.editable,
    disabled = props.disabled,
    onEditValue = props.onEditValue,
    labelStyle = props.labelStyle;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: labelStyle
  }, content.alreadyHaveSim.label), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.wrapper
  }, /*#__PURE__*/_react["default"].createElement(_icons.SIM, {
    active: value
  }), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 12
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [labelStyle, styles.preview, disabled && styles.previewDisabled]
  }, value)), editable && /*#__PURE__*/_react["default"].createElement(_Anchor["default"], {
    style: (styles.choose, labelStyle),
    title: value ? content.common.change : content.common.choose,
    onPress: onEditValue,
    disabled: disabled
  }));
}
StoredSIM.defaultProps = {
  editable: true
};
var styles = _reactNative.StyleSheet.create({
  container: {
    // paddingVertical: 8
  },
  wrapper: {
    flexDirection: 'row',
    padding: 12,
    borderRadius: _styles.radius.smedium,
    backgroundColor: _styles.backgroundColors.subtle
  },
  preview: {
    fontSize: 18
  },
  previewDisabled: {
    color: _styles.colors.trivial
  },
  choose: {
    fontSize: 15,
    color: _styles.colors.trivial,
    marginTop: 8
  }
});